/**
 * Gated cities: DB `regions.region_key` ↔ in-app pick label (English).
 * Cities with `key: null` in catalog are not waitlisted via DB.
 */
import { REGION_CITY_ROWS } from './regionsCatalog';

export const WAITLIST_CITY_TO_REGION_KEY = {
  ...Object.fromEntries(REGION_CITY_ROWS.filter((r) => r.key).map((r) => [r.pick, r.key])),
  'Ha Noi': 'hanoi',
  'Ho Chi Minh City': 'hochiminh',
};

export function getRegionKeyForCityLabel(city) {
  return WAITLIST_CITY_TO_REGION_KEY[city] || null;
}

export function isRegionRowOpen(row) {
  if (!row) return true;
  return !!row.is_open;
}
